import React from "react";
import { pieceKind, Player } from "../../types/game";
import { theme } from "../../style/theme";
import { icons } from "../../style/icons";
import { hexPolygonPoints } from "../../game/geometry";
import { useApp } from "../../contexts/app";

export const BoardPieceImage = ({
  kind,
  owner,
}: {
  kind: pieceKind;
  owner: Player;
}) => {
  const {
    state: { game },
    dispatch,
  } = useApp();

  const isClickable =
    !game.onlineGameId ||
    (game.onlineGameId && game.turnOfPlayer.id === game.localPlayerId);

  return (
    <div className="position-relative pieceSize">
      <div
        className="pointer-events-none pieceSize"
        style={{
          left: 0,
          top: 0,
          position: "absolute",
        }}
      >
        <svg
          className="pointer-events-none"
          width="100%"
          height="100%"
          viewBox={`${-1.2} ${-1} ${2 * 1.2} ${2 * 1}`}
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
        >
          <polygon
            className={`pointer-events-all hover-pointer ${
              theme.board.piece.fillClass[owner.id]
            } ${isClickable && game.action.placing === kind ? "shadow" : ""}`}
            points={hexPolygonPoints}
            stroke={theme.board.piece.stroke.colour}
            strokeWidth={theme.board.piece.stroke.width}
            onClick={
              isClickable
                ? () => {
                    console.log("go");
                    dispatch({
                      type: "SET_SELECTED_PIECE_TO_PLACE",
                      payload: { kind },
                    });
                  }
                : () => {}
            }
          />
        </svg>
      </div>

      <img
        className="pieceSize"
        src={icons.classic[kind]}
        alt={kind}
        style={{
          left: 0,
          top: 0,
          padding: "0.9rem",
          position: "absolute",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};
